<template>
  <div>
    <v-layout wrap justify-center v-if="isSubmitInvitationCodePending" mt-12>
      <v-flex xs6>
        <v-progress-linear indeterminate/>
      </v-flex>
    </v-layout>
    <v-layout wrap v-if="invitingUserErrorMsg">
      <v-flex xs12 text-center mt-12 pt-12>
        <div><v-icon class="red--text mt-12">mdi-close</v-icon></div>
        <div class="red--text"><b>{{ $t('a') }}</b></div>
        <div class="mt-6">{{ invitingUserErrorMsg }}</div>
        <div class="mt-12"><a class="textAsLink" href="/consultant/dossiers">{{ $t('b') }}</a></div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

export default {
  data: () => ({
    isSubmitInvitationCodePending: false,
    invitingUserErrorMsg: ''
  }),
  async mounted() {
    this.isSubmitInvitationCodePending = true
    
    if (this.$route.query.setUserLocale) {
      this.$functions.httpsCallable('updateUser')({
        locale: this.$route.query.setUserLocale
      })
    }

    const response = await this.$functions.httpsCallable('consultantSubmitInvitationCode')({
      codeToInviteAnyConsultant: this.$route.params.invitationCode
    })

    if (response.data && response.data.error) {
      if (response.data.errorCode === 'no-company-has-this-codeToInviteAnyConsultant') this.invitingUserErrorMsg = this.$t('c')
      else if (response.data.errorCode === 'company-has-no-credits-left') this.invitingUserErrorMsg = this.$t('d')
      else if (response.data.errorCode === 'consultant-was-already-invited-to-create-a-dossier') {
        this.$router.push(`/consultant/dossiers`)
        // this.invitingUserErrorMsg = this.$t('e')
      }
      else this.invitingUserErrorMsg = ' '
      
      this.isSubmitInvitationCodePending = false
    } else {
      this.$router.push(`/consultant/dossiers/${response.data.dossierId}/upload-cv`)
    }

  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Erreur",
    "b": "Retour à l'accueil",
    "c": "Le lien d'invitation ne correspond à aucune entreprise.",
    "d": "L'entreprise qui vous a invité n'a plus de crédit disponible dans son abonnement.",
    "e": "Vous avez déjà un dossier partagé avec cette entreprise."
  },
  "en": {
    "a": "Error",
    "b": "Back to home",
    "c": "The invitation link doesn't correspond to any company.",
    "d": "The company which invited you doesn't have any available credit in their subscription.",
    "e": "You already have a shared CV with this company."
  }
}
</i18n>
